var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    fill: "#333333",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.97,26.91H3.09V3.09h23.81v15.87l3.09,3.09V3.09c0-1.71-1.39-3.09-3.09-3.09H3.09C1.39,0,0,1.39,0,3.09v23.81c0,1.71,1.39,3.09,3.09,3.09h18.97l-3.09-3.09Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m29.12,25.53l-4.46-4.46c-.49-.49-1.22-.58-1.81-.27l-.99-.99c1.29-1.58,2.06-3.58,2.06-5.76,0-5.08-4.18-9.21-9.33-9.21S5.26,8.96,5.26,14.04s4.18,9.21,9.33,9.21c1.81,0,3.5-.52,4.93-1.41l1.13,1.13c-.14.24-.22.5-.22.78,0,.41.16.8.45,1.09l4.46,4.46c.3.3.7.45,1.09.45s.79-.15,1.09-.45l1.59-1.59c.29-.29.45-.68.45-1.09s-.16-.8-.45-1.09ZM8.36,14.04c0-3.37,2.8-6.12,6.24-6.12s6.24,2.74,6.24,6.12-2.8,6.12-6.24,6.12-6.24-2.74-6.24-6.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/viewIcon.179de099996bd0797c564319be6c86d4.svg";
export { ForwardRef as ReactComponent };